import { trustStats } from '@/mocks/categories';

export default function TrustStats() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative overflow-hidden">
      {/* Subtle line pattern background */}
      <div className="absolute inset-0 line-pattern opacity-50"></div>
      {/* Top divider */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/40 to-transparent"></div>
      {/* Decorative orb */}
      <div className="bg-orb bg-orb-primary w-[400px] h-[400px] -bottom-[100px] -left-[100px] animate-orb-float-slow opacity-40"></div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 relative">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-[55%]">
            <h2 className="font-heading font-semibold text-[34px] md:text-[40px] leading-[1.2] text-foreground-950">
              Trusted by
              <br />
              Global Buyers
              <br />
              <span className="text-foreground-300">Daily</span>
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-10">
              {trustStats.map((stat, idx) => (
                <div
                  key={stat.label}
                  className={`${idx > 0 ? 'border-l border-background-300/60 pl-5' : ''}`}
                >
                  <div className={`text-[36px] md:text-[44px] font-bold font-heading leading-none ${
                    idx % 2 === 0 ? 'text-primary-500' : 'text-accent-500'
                  }`}>
                    {stat.value}
                  </div>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-snug">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[45%] relative h-[300px] md:h-[380px] rounded-3xl overflow-hidden bg-gradient-to-br from-accent-100/60 via-background-100 to-primary-100/40">
            {/* Animated abstract shapes */}
            <div className="absolute top-[15%] left-[10%] w-[100px] h-[100px] rounded-2xl bg-background-50/60 rotate-[15deg]"></div>
            <div className="absolute top-[35%] right-[15%] w-[120px] h-[80px] rounded-full bg-accent-200/40 rotate-[-10deg]"></div>
            <div className="absolute bottom-[20%] left-[25%] w-[140px] h-[140px] rounded-3xl bg-primary-100/50 rotate-[5deg]"></div>
            <div className="absolute bottom-[30%] right-[8%] w-[80px] h-[80px] rounded-2xl bg-background-50/70 rotate-[-25deg]"></div>
            <div className="absolute top-[20%] right-[30%] w-[60px] h-[60px] rounded-full bg-accent-300/30"></div>
            {/* Extra floating ring */}
            <div className="floating-ring w-[200px] h-[200px] top-[10%] left-[40%] animate-rotate-slow opacity-30"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto rounded-2xl bg-background-50/80 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-accent-500"></i>
                </div>
                <p className="mt-3 text-sm font-medium text-foreground-700">Verified & Trusted</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}